<div class="wrapper round-big">
  <div class="top-container flex-dynamic">
    @if (!me) {
      @if (isTopAdmirer()) {
        <div class="top-container__title color-void font-weight-500">You're Top Admirer!</div>
        <p class="description color-ash t-8@r mb-0">
          Well done! {{ profile.username }} will be notified and see this badge on your profile.
        </p>
      }

      @if (!isTopAdmirer() && !isMyBidCapped()) {
        <div class="top-container__title color-void font-weight-500 mb-1@r">Become a Top Admirer</div>
        <p class="description color-ash t-8@r mb-0">
          Show {{ profile.username }} you're serious by becoming a Top Admirer.
        </p>
      }
    } @else {
      <div class="top-container__title color-void font-weight-500">Your Top Admirers</div>
      <p class="description color-ash t-8@r mb-0">These members are serious about getting your attention.</p>
    }
  </div>
  @if (!isMyBidCapped() && !me) {
    <button
      class="become-admirer-button white-space-nowrap"
      sbButton
      [block]="'mobile'"
      [bold]="true"
      [size]="'big'"
      [variant]="'fill-purple-gradient'"
      (click)="placeBid.emit()"
    >
      {{ isTopAdmirer() ? 'Increase Your Bid' : 'Become a Top Admirer' }}
    </button>
  }

  @if (displayBids().length) {
    <div class="leaderboard mt-3@r">
      @for (bid of displayBids(); track bid.id) {
        <ng-template #profileTpl>
          <div class="leaderboard-entry flex-row-all" [class.leaderboard-entry--first]="$first">
            <div class="badge-wrapper">
              @if (bid.rankingPlace <= DISTINGUISHED_BIDS_COUNT) {
                <sb-top-admirer-badge [place]="bid.rankingPlace" />
              } @else {
                <div class="t-9@r font-weight-500 color-ash">
                  {{ bid.rankingPlace }}
                </div>
              }
            </div>
            <div
              class="leaderboard-entry__img img-before circle"
              [class.leaderboard-entry__img--blurred]="!me"
              [style.--img-bg]="bid.image_url | bg"
            ></div>
            @if (!me) {
              <div class="profile-first-letter circle center-flex color-white font-weight-500">
                {{ bid.name | uppercase }}
              </div>
            }
            <div class="t-9@r ml-1@r font-weight-500">
              @if (!me) {
                @if (account.id === bid.benefactor_id) {
                  You
                } @else {
                  @if ($first) {
                    Top Admirer
                  } @else {
                    {{ bid.name | obfuscateName }}
                  }
                }
              } @else {
                {{ bid.full_name }}
              }
            </div>
            @if (me && !bid.disabled) {
              <i class="nc-icon nc-arrow-right color-iron ml-auto i-9@r"></i>
            }
            @if (!me) {
              <div class="t-9@r ml-auto font-weight-500">
                <i class="nc-icon nc-credits mr-1 leaderboard-entry__credits-icon"></i>{{ bid.amount }}
              </div>
            }
          </div>
          @if (!$last) {
            <hr class="bg-cloud border-radius-pill opacity-30 height-2" />
          }
        </ng-template>

        @if (me && !bid.disabled) {
          <a class="display-block" [routerLink]="['/next/profile', bid.benefactor_browse_id]">
            <ng-container *ngTemplateOutlet="profileTpl" />
          </a>
        } @else {
          <ng-container *ngTemplateOutlet="profileTpl" />
        }
      }

      @if (me && bids.length > displayBids().length) {
        <button
          class="mh-auto leaderboard__load-more mt-2"
          sbButton
          (click)="displayBids().length < MAX_VISIBLE_BIDS_COUNT ? viewMore() : viewAll()"
        >
          <sb-icon [name]="'big-add-thick'" /> View
          {{ displayBids().length < MAX_VISIBLE_BIDS_COUNT ? 'More' : 'All' }}
        </button>
      }
    </div>
  }
</div>
